import React, {useEffect, useState} from 'react';
import './FAQCollapse.scss';
import {
    constructPurchasedPrice,
    setStatusStyle
} from 'app/Components/Page/TransactionSummaryPage/Shared/HelperFunctions';
import {actionDescription} from "app/Components/Page/TransactionSummaryPage/Shared/Constants";
import arrow from '../../Shared/Buttons/images/arrow.svg';

const FAQCollapse = ({cardTitle, hasChildren, isOpen, price, group, dealType,campaignDesc}) => {
    const [isCollapseOpen, setIsCollapseOpen] = useState(false);
    let iconArrow = isCollapseOpen ? 'iconArrowUp' : 'iconArrowDown';

    const handleCollapse = () => {
        setIsCollapseOpen(!isCollapseOpen);
    };

    return (
        <React.Fragment>
            <button className='collapse-button' onClick={handleCollapse}>
                <label className='collapse-button__label'>{cardTitle}</label>
                {price}

                {hasChildren && <div className={`collapse-button__icon ${iconArrow}`} style={{ backgroundImage: arrow.bg() }}></div>}
            </button>
            {isCollapseOpen && group && (
                <>
                    {group.map((element, index) => (
                        <div className='block-frame__list-info equipment-summary__group-list' key={index.toString() + element.name}>
                            <div className='block-frame__row block-frame__row--2'>
                                <label>{element.name}</label>
                                {constructPurchasedPrice(element.price, element.numOfInstallments, element.nextPaymentAmount, dealType, element.effectiveInterest)}
                            </div>
                        </div>
                    ))}

                    {campaignDesc &&
                        <>
                            <p style={{'margin': '0px 0px 0 0'}}
                               className={'block-frame__status block-frame__status--4'}>
                                מבצע
                            </p>
                            <label>{campaignDesc}</label>
                        </>

                    }
                </>
            )}

        </React.Fragment>
    );
};
export default FAQCollapse;
